import { Flex, Text } from 'components'
import { ChartProps, ParsedChartProps } from 'types'
import './chartStyle.css'
import { BarChart, ComboChart, PieChart } from './charts'

export default function Chart({
  values,
  valueInfo,
  data,
  categories,
  type,
  onSelect,
  ...rest
}: ChartProps) {
  if (!data?.length || !categories?.length || !values?.length) return null

  const _values = values.map((v, i) => ({ field: v, ...valueInfo?.[i] })) || []
  const _type = type || (data.length < 5 ? 'pie' : 'combo')
  const chartProps = { categories, values: _values, data, type: _type, ...rest }

  return (
    <Flex flex={1} fontSize="11px" direction="column" overflow="hidden">
      <ChartVisual onSelect={onSelect} {...chartProps} />
    </Flex>
  )
}

function ChartVisual(props: ParsedChartProps) {
  switch (props.type) {
    case 'pie':
      return <PieChart {...props} />
    case 'combo':
      return <ComboChart {...props} />
    case 'bars':
      return <BarChart {...props} />
    default:
      return <Text>chart missing</Text>
  }
}
